import { useSelector, useDispatch } from "react-redux";
import { logout } from "@/features/auth/store/sessionSlice";
import { useBrowserSession } from "@/shared/hooks/useBrowserSession";
import { RootState, AppDispatch } from "@/store";

export const useActivityChannel = () => {
  const user = useSelector((state: RootState) => state.session.user);
  const authenticated = useSelector((state: RootState) => state.session.isAuthenticated);
  const dispatch = useDispatch<AppDispatch>();
  return useBrowserSession(authenticated ? user?.representative?.id : undefined, (isVoluntary) => dispatch(logout({ isVoluntary })));
};
